<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters v-if="isAuthorized">
            <v-col>
                <v-tabs
                    v-model="activeTab"
                    style="border-radius: 16px; overflow: hidden"
                    class="bg-white"
                    id="Devis"
                >
                    <v-tab
                        value="Quotation"
                        href="#Quotation"
                        data-cy="invoiceTable-quotation-tab"
                        >{{ $t("invoice-table.devis") }}</v-tab
                    >
                    <v-tab value="Invoice" href="#Invoice" data-cy="invoiceTable-invoice-tab">{{
                        $t("invoice-table.factures")
                    }}</v-tab>
                    <v-tab
                        value="Outstanding"
                        href="#Outstanding"
                        data-cy="invoiceTable-outstanding-tab"
                        :disabled="!currentUser.showOutStandingClient"
                        >{{ $t("invoice-table.encours-clients") }}</v-tab
                    >
                    <v-tab
                        value="BillDelivery"
                        href="#BillDelivery"
                        data-cy="invoiceTable-billDelivery-tab"
                        >{{ $t("invoice-table.bon-de-livraison") }}</v-tab
                    >
                    <v-tab
                        value="Product"
                        href="#Product"
                        data-cy="invoiceTable-product-tab"
                        id="Produits"
                        >{{ $t("invoice-table.produits") }}</v-tab
                    >
                    <v-tab
                        value="Configuration"
                        href="#Configuration"
                        data-cy="invoiceTable-configuration-tab"
                        id="Configuration"
                        >{{ $t("invoice-table.configuration") }}</v-tab
                    >
                    <v-tab
                        value="Rights"
                        href="#Rights"
                        data-cy="invoiceTable-rights-tab"
                        id="Rights"
                        v-if="
                            !(
                                selectedCompany.profile &&
                                selectedCompany.profile.managementAuthorization &&
                                selectedCompany.profile.managementAuthorizations &&
                                selectedCompany.profile.managementAuthorizations.client
                            )
                        "
                        >{{ $t("invoice-table.mes-droits") }}</v-tab
                    >
                </v-tabs>
                <v-tabs-window v-model="activeTab" style="background-color: transparent !important">
                    <v-window-item value="Quotation">
                        <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                            <v-col cols="2">
                                <v-btn-primary
                                    block
                                    @click="addDocument('quotation')"
                                    data-cy="invoice-new-quotation"
                                    >{{ $t("invoice-table.ajouter") }}</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <v-btn-primary
                                    block
                                    :disabled="!!disableConvertInvoicesDialog"
                                    @click.stop="convertMultipleInvoiceDialog = true"
                                    data-cy="InvoiceTable-convertInvoice"
                                    v-tooltip="displayDisableConvertInvoicesDialog"
                                    >{{ $t("invoice-table.convertir") }}
                                </v-btn-primary>
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <v-btn-primary
                                    block
                                    :loading="synchronisationLoading"
                                    v-if="activeTab === 'Quotation'"
                                    @click.stop="retrieveSignatures()"
                                    data-cy="InvoiceTable-synchroniseSignatures"
                                    v-tooltip="$t('invoice-table.recuperer-les-signatures')"
                                >
                                    {{ $t("invoice-table.synchroniser") }}
                                </v-btn-primary>
                                <!-- <v-tooltip>
                                    <template v-slot:activator="{ props }">
                                        <div v-bind="props">
                                            <v-btn-primary
                                                block
                                                :disabled="!!disableConvertInvoicesDialog"
                                                @click.stop="convertMultipleInvoiceDialog = true"
                                                data-cy="InvoiceTable-convertInvoice"
                                                >{{ $t("invoice-table.convertir") }}</v-btn-primary
                                            >
                                        </div>
                                    </template>
                                    <span v-if="displayDisableConvertInvoicesDialog">{{
                                        displayDisableConvertInvoicesDialog
                                    }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <v-btn-primary
                                    block
                                    :loading="synchronisationLoading"
                                    v-if="activeTab === 'Quotation'"
                                    @click.stop="retrieveSignatures()"
                                    data-cy="InvoiceTable-synchroniseSignatures"
                                    v-tooltip="$t('invoice-table.recuperer-les-signatures')"
                                >
                                    {{ $t("invoice-table.synchroniser") }}
                                </v-btn-primary> -->
                            </v-col>
                            <v-col cols="5" class="pl-2">
                                <oss-filter-bar
                                    v-model:text="search"
                                    v-model:status="status"
                                    v-model:thirdPartyCompanyName="clientCompanyName"
                                    @update:thirdPartyCompanyName="setThirdPartyCompanyName($event)"
                                    :status-list="statusList"
                                    :companyId="selectedCompany.id"
                                    type="SALES_INVOICE"
                                    @clear-filter="clearFilter"
                                    data-cy="InvoiceTable-searchQuotation"
                                />
                            </v-col>
                            <v-col cols="1" class="pl-2" v-if="!$vuetify.display.mobile">
                                <TutorialButtonDialog :starterComponents="'InvoiceTable;'">
                                </TutorialButtonDialog>
                            </v-col>
                        </v-row>
                        <v-data-table-server
                            :headers="quotationsHeaders"
                            :items="quotations"
                            v-model:page="quotationPagination.page"
                            v-model:items-per-page="quotationPagination.rowsPerPage"
                            v-model:items-length="quotationPagination.totalItems"
                            v-model:sort-by="quotationsSortBy"
                            :items-per-page-options="[10, 25, 50]"
                            :loading="quotationLoading"
                            class="table rounded-xl"
                            fixed-header
                            max-height="60vh"
                            :multi-sort="false"
                            data-cy="InvoiceTable-QuotationTable"
                        >
                            <template v-slot:item="{ item, index }">
                                <tr
                                    @click="
                                        $router.push({
                                            name: 'quotationEdition',
                                            params: { companyId: companyId, id: item.id },
                                        })
                                    "
                                    :data-cy="`InvoiceTable-quotation_${index}`"
                                >
                                    <td class="text-center" style="width: 64px">
                                        <v-checkbox
                                            v-model="selectedInvoices"
                                            @click.stop="() => {}"
                                            :disabled="isNotSelectionable(item.id)"
                                            class="pa-0 ma-0"
                                            color="primary"
                                            :value="item.id"
                                        >
                                        </v-checkbox>
                                    </td>
                                    <td>{{ item.title || "" }}</td>
                                    <td>{{ item.client ? item.client.name : "-" }}</td>
                                    <td>{{ $t(`invoice.${item.status}`) }}</td>
                                    <td>
                                        <VChipTag size="small">
                                            <v-icon size="small" left>$label</v-icon>
                                            {{
                                                item.status === "DRAFT" ? "Brouillon" : item.number
                                            }}
                                        </VChipTag>
                                    </td>
                                    <td>{{ formatDate(item.date) }}</td>
                                    <td>{{ formatDate(item.dueDate) }}</td>
                                    <td v-if="isVatSubject" class="text-left">
                                        {{ newCommonFormatCurrency(item.netAmount, undefined) }}
                                    </td>
                                    <td class="text-left">
                                        {{ newCommonFormatCurrency(item.grossAmount, undefined) }}
                                    </td>
                                    <td>
                                        <HasMailBeenRead :item="item" />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table-server>
                    </v-window-item>
                    <v-window-item value="Invoice">
                        <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                            <v-col cols="2" v-if="$store.state.invoice.skipWizard">
                                <v-menu open-on-hover offset-y location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-primary
                                            block
                                            v-bind="props"
                                            @click="addDocument('invoice')"
                                            data-cy="invoices-new-invoice"
                                            >Ajouter</v-btn-primary
                                        >
                                    </template>
                                    <v-list nav>
                                        <v-list-item @click="addDocument('invoice')">
                                            <v-list-item-title>Une facture</v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="x-small">$fa-chevron-right</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item @click="addDocument('invoiceRecurrence')">
                                            <v-list-item-title
                                                >Une facture récurrente</v-list-item-title
                                            >
                                            <template v-slot:append>
                                                <v-icon size="x-small">$fa-chevron-right</v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                            <v-col cols="2" v-else>
                                <v-btn-primary
                                    block
                                    @click="addDocument('invoice')"
                                    data-cy="invoiceTable-new-invoice"
                                    >Ajouter</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <v-btn-primary
                                    block
                                    @click="
                                        $router.push({
                                            name: 'invoiceMatrixNew',
                                            params: { companyId: companyId },
                                        })
                                    "
                                    data-cy="invoiceTable-new-invoiceMatrix"
                                    >Matrice</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <!-- <v-btn

                                    color="secondary"
                                    elevation="0"
                                    height="40px"
                                    class="rounded-lg gradient"
                                    block
                                    :disabled="numberInvoicesSendableByMails === 0"
                                    :loading="sendingMailLoading"
                                    @click.stop="sendMultipleMailsDialog = true"
                                    data-cy="invoices-send-mails"
                                >Envoyer par mail</v-btn> -->
                                <!-- commenté car manquant de clarté pour les utilisateurs -->
                            </v-col>
                            <v-col cols="5" class="pl-2">
                                <oss-filter-bar
                                    v-model:text="search"
                                    v-model:status="status"
                                    type="SALES_INVOICE"
                                    v-model:thirdPartyCompanyName="clientCompanyName"
                                    @update:thirdPartyCompanyName="setThirdPartyCompanyName($event)"
                                    :status-list="statusList"
                                    :companyId="selectedCompany.id"
                                    v-model:minPrice="minAmount"
                                    v-model:maxPrice="maxAmount"
                                    v-model:startDate="startDate"
                                    v-model:endDate="endDate"
                                    @clear-filter="clearFilter"
                                    data-cy="InvoiceTable-searchInvoice"
                                />
                            </v-col>
                            <v-col cols="1" class="pl-2" v-if="!$vuetify.display.mobile">
                                <TutorialButtonDialog :starterComponents="'InvoiceTable;'">
                                </TutorialButtonDialog>
                            </v-col>
                        </v-row>
                        <v-data-table-server
                            :headers="invoicesHeaders"
                            :items="invoices"
                            v-model:page="invoicePagination.page"
                            v-model:items-per-page="invoicePagination.rowsPerPage"
                            v-model:items-length="invoicePagination.totalItems"
                            v-model:sort-by="invoicesSortBy"
                            :items-per-page-options="[10, 25, 50]"
                            :loading="invoiceLoading"
                            class="table rounded-xl"
                            fixed-header
                            max-height="60vh"
                            :multi-sort="false"
                            data-cy="InvoiceTable-InvoiceTable"
                        >
                            <template v-slot:item="{ item, index }">
                                <tr
                                    @click="
                                        $router.push({
                                            name: 'invoiceEdition',
                                            params: { companyId: companyId, id: item.id },
                                        })
                                    "
                                    :data-cy="`InvoiceTable-invoice_${index}`"
                                    class="clickable"
                                >
                                    <td class="text-center" style="width: 64px">
                                        <v-checkbox
                                            v-model="selectedInvoices"
                                            @click.stop="() => {}"
                                            :disabled="isNotSelectionable(item.id)"
                                            class="pa-0 ma-0"
                                            color="primary"
                                            :value="item.id"
                                        >
                                        </v-checkbox>
                                    </td>
                                    <td>{{ item.title || "-" }}</td>
                                    <td>{{ $t(`invoice.type.${item.type}`) }}</td>
                                    <td>{{ item.client ? item.client.name : "-" }}</td>
                                    <td>{{ $t(`invoice.${item.status}`) }}</td>
                                    <td>
                                        <VChipTag size="small">
                                            <v-icon size="small" left>$label</v-icon>
                                            {{
                                                item.status === "DRAFT" ? "Brouillon" : item.number
                                            }}
                                        </VChipTag>
                                    </td>
                                    <td>{{ formatDate(item.date) }}</td>
                                    <td>
                                        {{
                                            item.type === "INVOICE"
                                                ? formatDate(item.dueDate)
                                                : formatDate(item.endDate)
                                        }}
                                    </td>
                                    <td
                                        v-if="isVatSubject && item.type === 'CREDIT_NOTE'"
                                        style="color: red"
                                        class="text-right"
                                    >
                                        {{ newCommonFormatCurrency(item.netAmount, undefined) }}
                                    </td>
                                    <td v-else-if="isVatSubject" class="text-right">
                                        {{ newCommonFormatCurrency(item.netAmount, undefined) }}
                                    </td>
                                    <td
                                        v-if="item.type === 'CREDIT_NOTE'"
                                        style="color: red"
                                        class="text-right"
                                    >
                                        {{ newCommonFormatCurrency(item.grossAmount, undefined) }}
                                    </td>
                                    <td v-else class="text-right">
                                        {{ newCommonFormatCurrency(item.grossAmount, undefined) }}
                                    </td>
                                    <td>
                                        <HasMailBeenRead :item="item" />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table-server>
                        <!-- </v-card-text>
                        </v-card> -->
                    </v-window-item>
                    <v-window-item value="BillDelivery">
                        <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                            <v-col cols="2">
                                <v-btn-primary
                                    block
                                    @click="addDocument('billDelivery')"
                                    data-cy="invoiceTable-new-billDelivery"
                                    >Ajouter</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="2" class="pl-2">
                                <!-- <v-btn-primary
                                    block
                                    :disabled="!!disableConvertInvoicesDialog"
                                    @click.stop="convertMultipleInvoiceDialog = true"
                                    data-cy="InvoiceTable-convertBillDelivery"
                                    v-tooltip="displayDisableConvertInvoicesDialog"
                                    >Convertir</v-btn-primary
                                > -->
                                <v-tooltip>
                                    <template v-slot:activator="{ props }">
                                        <div v-bind="props">
                                            <v-btn-primary
                                                block
                                                :disabled="!!disableConvertInvoicesDialog"
                                                @click.stop="convertMultipleInvoiceDialog = true"
                                                data-cy="InvoiceTable-convertBillDelivery"
                                                >Convertir</v-btn-primary
                                            >
                                        </div>
                                    </template>
                                    <span v-if="displayDisableConvertInvoicesDialog">{{
                                        displayDisableConvertInvoicesDialog
                                    }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="7" class="pl-2">
                                <oss-filter-bar
                                    v-model:text="search"
                                    v-model:status="status"
                                    v-model:thirdPartyCompanyName="clientCompanyName"
                                    @update:thirdPartyCompanyName="setThirdPartyCompanyName($event)"
                                    :status-list="statusList"
                                    :companyId="selectedCompany.id"
                                    type="SALES_INVOICE"
                                    @clear-filter="clearFilter"
                                    data-cy="InvoiceTable-billDelivery"
                                />
                            </v-col>
                            <v-col cols="1" class="pl-2" v-if="!$vuetify.display.mobile">
                                <TutorialButtonDialog :starterComponents="'InvoiceTable;'">
                                </TutorialButtonDialog>
                            </v-col>
                        </v-row>
                        <v-data-table-server
                            :headers="billDeliveriesHeaders"
                            :items="billOfDelivery"
                            v-model:page="billDeliveryPagination.page"
                            v-model:items-per-page="billDeliveryPagination.rowsPerPage"
                            v-model:items-length="billDeliveryPagination.totalItems"
                            v-model:sort-by="billsDeliverySortBy"
                            :items-per-page-options="[10, 25, 50]"
                            :loading="billDeliveryLoading"
                            class="table rounded-xl"
                            fixed-header
                            max-height="60vh"
                            :multi-sort="false"
                            data-cy="InvoiceTable-BillDeliveryTable"
                        >
                            <template v-slot:item="{ item, index }">
                                <tr
                                    @click="
                                        $router.push({
                                            name: 'billDeliveryEdition',
                                            params: { companyId: companyId, id: item.id },
                                        })
                                    "
                                    :data-cy="`InvoiceTable-billDelivery_${index}`"
                                >
                                    <td class="text-center" style="width: 64px">
                                        <v-checkbox
                                            v-model="selectedInvoices"
                                            @click.stop="() => {}"
                                            :disabled="isNotSelectionable(item.id)"
                                            class="pa-0 ma-0"
                                            color="primary"
                                            :value="item.id"
                                        >
                                        </v-checkbox>
                                    </td>
                                    <td>{{ item.client ? item.client.name : "/" }}</td>
                                    <td>
                                        {{ $t(`invoice.${item.status}`) }}
                                        <v-progress-linear
                                            color="secondary"
                                            height="10"
                                            buffer-value="0"
                                            v-if="
                                                item.extraData &&
                                                item.extraData.stepCount &&
                                                item.extraData.step < item.extraData.stepCount
                                            "
                                            stream
                                            :model-value="(100 * item.step) / item.stepCount"
                                        />
                                    </td>
                                    <td>
                                        <VChipTag size="small">
                                            <v-icon size="small" left>$label</v-icon>
                                            {{
                                                item.status === "DRAFT" ? "Brouillon" : item.number
                                            }}
                                        </VChipTag>
                                    </td>
                                    <td>{{ formatDate(item.date) }}</td>
                                </tr>
                            </template>
                        </v-data-table-server>
                        <!-- </v-card-text>
                        </v-card> -->
                    </v-window-item>
                    <v-window-item value="Product">
                        <!-- <v-card class="default_card">
                            <v-card-text :style="$vuetify.display.mobile ?
                                'width: 100%; height: 70vh; overflow-y: auto; overflow-x: hidden' :
                                'width: 100%; height: 66vh; overflow-y: auto; overflow-x: hidden'"
                            > -->
                        <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                            <v-col cols="2" class="px-2">
                                <v-btn-primary
                                    block
                                    @click="
                                        productId = '';
                                        productDialog = true;
                                    "
                                    data-cy="invoiceTable-newProduct"
                                    >Nouveau produit</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="2" class="px-2">
                                <v-btn-primary
                                    block
                                    @click="importProductsDialog = true"
                                    data-cy="invoiceTable-importProduct"
                                    >Importer produits</v-btn-primary
                                >
                            </v-col>
                            <v-col cols="7" class="px-2" />
                            <v-col cols="1" class="pl-2">
                                <TutorialButtonDialog
                                    v-if="!$vuetify.display.mobile"
                                    :starterComponents="'InvoiceTable;'"
                                >
                                </TutorialButtonDialog>
                            </v-col>
                        </v-row>
                        <v-data-table-server
                            :headers="productHeaders"
                            :items="products"
                            v-model:page="productPagination.page"
                            v-model:items-per-page="productPagination.rowsPerPage"
                            v-model:items-length="productPagination.totalItems"
                            v-model:sort-by="productsSortBy"
                            :items-per-page-options="[10, 25, 50]"
                            :loading="productLoading"
                            class="table rounded-xl"
                            fixed-header
                            max-height="60vh"
                            :multi-sort="false"
                            data-cy="InvoiceTable-productTable"
                        >
                            <template v-slot:item="{ item }">
                                <tr @click="editProduct(item)">
                                    <td>{{ item.reference }}</td>
                                    <td>
                                        <VChipTag class="text mr-1" v-if="item.tag">
                                            <span :style="'color:' + labelTextColor + ';'">{{
                                                item.tag.name
                                            }}</span>
                                        </VChipTag>
                                        {{ item.title }}
                                    </td>
                                    <td>{{ item.type }}</td>
                                    <!-- <td class="text-right" v-if="selectedCompany.vatSystem !== 'NotSubjectTo'">{{ item.percentage ? item.percentage + "%":"" }}</td> -->
                                    <td class="text-right">
                                        {{ newCommonFormatCurrency(item.unitPrice, undefined) }}
                                    </td>
                                    <td v-if="isVatSubject">{{ item.vatRate }}%</td>
                                    <td>
                                        <v-switch
                                            v-model="item.outDated"
                                            @update:model-value="setOutDatedProduct(item, $event)"
                                            @click.stop=""
                                        />
                                        <!-- </v-btn> -->
                                    </td>
                                    <td>
                                        <VSwitch
                                            :model-value="item.stock"
                                            @update:model-value="
                                                (value) => setStockProduct(item.id, value)
                                            "
                                            @click.stop="() => {}"
                                            :disabled="
                                                (item.accountableAccount &&
                                                    item.accountableAccount.name === '707') ||
                                                (item.stockOperations &&
                                                    !!item.stockOperations.length)
                                            "
                                        />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table-server>
                    </v-window-item>
                    <v-window-item value="Configuration">
                        <InvoiceThemeEdition :companyId="companyId" />
                    </v-window-item>
                    <v-window-item value="Outstanding">
                        <Outstanding />
                    </v-window-item>
                    <v-window-item value="Rights" class="mt-2 rounded">
                        <v-card rounded class="pa-2">
                            <ProfileManagement
                                :companyId="companyId"
                                :companyUser="companyUser"
                                :invoiceMode="true"
                            />
                        </v-card>
                    </v-window-item>
                </v-tabs-window>
            </v-col>
        </v-row>
        <oss-dialog
            persistent
            v-model="invoiceDialog"
            :fullscreen="$vuetify.display.mobile"
            :title="dialogTitle"
            :actions="actions"
            prefixDataCy="InvoiceTable-valid"
        >
            <div class="d-flex" style="width: 85vw">
                <InvoiceEditWizard
                    ref="invoiceEditWizard"
                    :companyId="companyId"
                    :invoiceType="invoiceType"
                    :invoiceTableMode="true"
                    :actions="actions"
                />
            </div>
        </oss-dialog>
        <oss-dialog
            persistent
            v-model="productDialog"
            :max-width="!$vuetify.display.mobile ? '900px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :title="'Création d\'un produit'"
            :actions="productActions"
            v-if="productDialog"
        >
            <CreateInvoiceProduct
                :id="productId"
                :companyId="companyId"
                :saveable="false"
                :vatSubject="isVatSubject"
                :actions="productActions"
                @product-saved="onProductSaved"
            />
        </oss-dialog>
        <oss-dialog
            v-model="importProductsDialog"
            :minWidth="width"
            title="Importez vos produits"
            :actions="importActions"
        >
            <InvoiceProductImport
                v-if="importProductsDialog"
                ref="importComponent"
                :documentType="'INVOICE_PRODUCTS'"
                :actions="importActions"
                :selectedCompanyId="selectedCompany.id"
                @documentImported="onDocumentImported()"
                @width="changeWidth()"
            />
        </oss-dialog>
        <oss-dialog
            title="Conversion"
            v-model="convertMultipleInvoiceDialog"
            class="px-2"
            :valid-loading="convertMultipleInvoiceLoading"
            :valid-disabled="selectedInvoicesHaveOptionalLines"
            @valid="convertInvoice()"
            :previous-display="convertMultipleInvoiceDialogStep !== 'default'"
            @previous="convertMultipleInvoiceDialogStep = 'default'"
            data-cy="InvoiceTable-valid"
            v-if="convertMultipleInvoiceDialog"
            min-width="60vw"
        >
            <v-window v-model="convertMultipleInvoiceDialogStep">
                <v-window-item value="default">
                    <div class="pb-2" v-if="selectedInvoiceObjects.length > 1">
                        Regroupement de toutes les lignes des éléments suivants :
                    </div>
                    <v-row
                        no-gutters
                        class="pb-2"
                        v-for="(invoiceToConvert, index) in selectedInvoiceObjects"
                        :key="index"
                    >
                        <v-col cols="1" v-if="selectedInvoiceObjects.length > 1">
                            &emsp; {{ " - " }}
                        </v-col>
                        <v-col>{{
                            (invoiceToConvert.title || "Sans titre") +
                            (invoiceToConvert.grossAmount
                                ? ", " +
                                  newCommonFormatCurrency(invoiceToConvert.grossAmount, undefined)
                                : "")
                        }}</v-col>
                        <v-col class="d-flex justify-end">
                            <v-btn
                                dense
                                rounded
                                size="small"
                                elevation="0"
                                :color="
                                    invoicesIdHaveBeenChecked.find((e) => e === invoiceToConvert.id)
                                        ? 'secondary'
                                        : 'warning'
                                "
                                class="pl-2"
                                @click="
                                    convertMultipleInvoiceDialogStep = 'manageOptionalLines';
                                    invoiceWhichIsManagingOptionalLines = invoiceToConvert;
                                "
                                v-if="
                                    invoiceToConvert.lines &&
                                    invoiceToConvert.lines.length &&
                                    invoiceToConvert.lines.some((l) => l.isOptional)
                                "
                            >
                                <v-icon left>$fa-exclamation-triangle</v-icon>
                                Gérer les lignes 'en option'
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div>Voulez-vous générer :</div>
                    <v-radio-group v-model="conversionType" color="primary">
                        <v-radio
                            label="une facture"
                            value="INVOICE"
                            data-cy="InvoiceTable-invoice"
                        />
                        <v-radio
                            label="un devis"
                            value="QUOTATION"
                            :disabled="activeTab !== 'Invoice' && activeTab !== 'BillDelivery'"
                            data-cy="InvoiceTable-quotation"
                        />
                        <v-radio
                            label="un bon de livraison"
                            value="BILL_DELIVERY"
                            :disabled="activeTab !== 'Invoice' && activeTab !== 'Quotation'"
                            data-cy="InvoiceTable-billDelivery"
                        />
                    </v-radio-group>
                </v-window-item>
                <v-window-item
                    value="manageOptionalLines"
                    v-if="convertMultipleInvoiceDialogStep === 'manageOptionalLines'"
                >
                    <div class="pb-2">
                        Veuillez choisir les lignes 'en option' à conserver (les autres seront
                        supprimées)
                    </div>
                    <div
                        v-for="(line, index) in invoiceWhichIsManagingOptionalLines.lines"
                        :key="'line_' + index"
                    >
                        <v-row no-gutters>
                            <v-col cols="1" v-if="!line.isOptional" />
                            <v-col
                                cols="1"
                                class="d-flex align-center"
                                style="font-style: italic; font-size: 0.8em"
                                v-else
                                >En option</v-col
                            >
                            <v-checkbox
                                v-if="!line.isOptional"
                                v-model="trueValue"
                                disabled
                                color="primary"
                            />
                            <v-checkbox v-else v-model="line.keepTheLine" color="primary" />
                            <v-col cols="3" class="d-flex align-center"
                                ><oss-text-field
                                    v-model="line.title"
                                    label="Titre"
                                    hide-details
                                    dense
                                    outlined
                                    :disabled="true"
                            /></v-col>
                            <v-col cols="1" class="d-flex align-center pl-2"
                                ><oss-text-field
                                    v-model="line.reference"
                                    label="Ref"
                                    hide-details
                                    dense
                                    outlined
                                    :disabled="true"
                            /></v-col>
                            <v-col cols="1" class="d-flex align-center pl-2"
                                ><oss-text-field
                                    v-model="line.quantity"
                                    label="Qté"
                                    hide-details
                                    dense
                                    outlined
                                    :disabled="true"
                            /></v-col>
                            <v-col cols="2" class="d-flex align-center pl-2"
                                ><oss-text-field
                                    v-model="line.unitPrice"
                                    label="Prix unitaire"
                                    hide-details
                                    dense
                                    outlined
                                    :disabled="true"
                            /></v-col>
                            <v-col cols="2" class="d-flex align-center pl-2"
                                ><oss-text-field
                                    v-model="line.netAmount"
                                    label="Montant HT"
                                    hide-details
                                    dense
                                    outlined
                                    :disabled="true"
                            /></v-col>
                        </v-row>
                        <v-divider
                            v-if="index !== invoiceWhichIsManagingOptionalLines.lines.length - 1"
                        />
                    </div>
                    <v-row no-gutters>
                        <v-col class="d-flex justify-end pr-3">
                            <v-btn
                                elevation="0"
                                dense
                                rounded
                                @click="
                                    invoicesIdHaveBeenChecked.push(
                                        invoiceWhichIsManagingOptionalLines.id,
                                    );
                                    convertMultipleInvoiceDialogStep = 'default';
                                "
                            >
                                OK pour ce devis
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import gql from "graphql-tag";
import moment from "moment-timezone";
import colors from "vuetify/util/colors";
import { Apollo } from "@/decorators";
import { Invoice, InvoiceProduct } from "../../../../types";

// import Editor from "../../../src/components/editorMenu/Editor.vue";
import { NotificationBase } from "../NotificationBase";
import InvoiceEditWizard from "./InvoiceWizard.vue";
import CreateInvoiceProduct from "./CreateInvoiceProduct.vue";
import OssFilterBar from "../ossComponents/ossFilterBar.vue";
import InvoiceProductImport from "../import/InvoiceProductImport.vue";
import HasMailBeenRead from "../mail/HasMailBeenRead.vue";
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";
import InvoiceThemeEdition from "../invoiceTheme/InvoiceThemeEdition.vue";
import Outstanding from "../admin/Outstanding.vue";
import ProfileManagement from "../user/ProfileManagement.vue";

import { DialogAction } from "../../services/dialogAction";

import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import INVOICES_TO_SEND_BY_MAILS from "../../graphql/invoice/InvoicesToSendByMails.gql";
// import SEND_MULTIPLE_INVOICES_BY_MAILS from "../../graphql/invoice/MultipleInvoicesMailer.gql"
import CONVERT_INVOICES from "../../graphql/invoice/ConvertInvoices.gql";
import GET_SIGNATURES from "../../graphql/SynchroniseSignTransactions.gql";
import { emailPattern } from "../../services/emailServices";
import { getDBFormattedDate } from "../../services/dateServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { checkAccessRights } from "../../services/accessRightServices";
// import COMPANY_USER from "../../graphql/user/CompanyUser.gql"
import _ from "lodash";
import { defaultCompanyUser } from "@/services/user/companyUser";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";

import { Component, toNative, Watch } from "vue-facing-decorator";

type SelectedInvoiceForInvoiceTable = { lines: Array<any> } & Invoice;

@Component({
    components: {
        InvoiceEditWizard,
        CreateInvoiceProduct,
        OssFilterBar,
        HasMailBeenRead,
        TutorialButtonDialog,
        InvoiceThemeEdition,
        Outstanding,
        ProfileManagement,
        InvoiceProductImport,
    },
    emits: ["refresh"],
})
export class InvoiceTable extends NotificationBase {
    private readonly CLIENT_NAME_HEADER_VALUE = "client__name";

    @State2Way("updateInvoiceMinAmount", "invoiceFilter.minAmount")
    minAmount!: string;

    @State2Way("updateInvoiceMaxAmount", "invoiceFilter.maxAmount")
    maxAmount!: string;

    @State2Way("updateInvoiceSearch", "invoiceFilter.search")
    search!: string;

    @State2Way("updateInvoiceClientCompaniesSelected", "invoiceFilter.clientCompaniesSelected")
    clientCompaniesSelected: any[];

    @State2Way("updateQuotationPagination", "invoiceFilter.quotationPagination")
    quotationPagination!: any;

    @State2Way("updateInvoicePagination", "invoiceFilter.invoicePagination")
    invoicePagination!: any;

    @State2Way("updateBillDeliveryPagination", "invoiceFilter.billDeliveryPagination")
    billDeliveryPagination!: any;

    @State2Way("updateProductPagination", "invoiceFilter.productPagination")
    productPagination!: any;

    @State2Way("updateInvoiceStatus", "invoiceFilter.status")
    status: string;

    @State2Way("updateInvoiceFilter", "invoiceFilter.invoiceFilter")
    invoiceFilter!: any;

    tab = "one";

    get billDeliveryPaginationPage() {
        return this.billDeliveryPagination.page;
    }

    set billDeliveryPaginationPage(data) {
        this.billDeliveryPagination.page = data;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    invoiceDialog = false;
    invoiceType = "invoice";
    accountableAccountSelected = "";

    type = "ALL";
    allType = ["INVOICE", "CREDIT_NOTE", "INVOICE_MATRIX", "INVOICE_RECURRENT"];

    startDate: Date = null;
    endDate: Date = null;

    invoiceLoading = false;
    quotationLoading = false;
    productLoading = false;
    billDeliveryLoading = false;
    synchronisationLoading = false;

    productId = "";

    selectedInvoices: Array<string> = [];
    convertMultipleInvoiceDialog = false;
    conversionType: "QUOTATION" | "INVOICE" | "  BILL_DELIVERY" = "INVOICE";
    convertMultipleInvoiceDialogStep: "default" | "manageOptionalLines" = "default";
    invoiceWhichIsManagingOptionalLines: SelectedInvoiceForInvoiceTable = null;

    subjectMailToSend = "";
    textMail = "";
    mailAddressDestination = "";

    sendMultipleMailsDialog = false;
    isValid = false;
    mailAddressSender = "";
    sendingMailLoading = false;

    trueValue = true;
    invoicesIdHaveBeenChecked: Array<string> = [];

    productActions = {
        action: new DialogAction(),
    };

    importActions = {
        action: new DialogAction(),
    };

    actions = {
        action: new DialogAction(),
    };

    get companyUser() {
        if (this.currentUser.companyUser) {
            return this.currentUser.companyUser;
        }
        return _.cloneDeep(defaultCompanyUser);
    }

    get rules() {
        return {
            isEmail: (value) => {
                return emailPattern.test(value) || "E-mail invalide";
            },
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
        };
    }

    /**
     * Check if the company is subject to VAT
     */
    get isVatSubject() {
        return !isNotSubjectToVAT(this.selectedCompany.vatSystem);
    }

    get dialogTitle() {
        if (this.invoiceType === "invoice") {
            return "Création de facture";
        } else if (this.invoiceType === "quotation") {
            return "Création de devis";
        } else if (this.invoiceType === "billDelivery") {
            return "Création d'un bon de livraison";
        }
        return "Title";
    }

    get invoicesHeaders() {
        let headers = [];
        if (!isNotSubjectToVAT(this.selectedCompany.vatSystem)) {
            headers = [
                { title: "", value: "checkboxSelection", width: "64px", sortable: false },
                { title: "Titre", value: "title", sortable: true },
                { title: "Type", value: "type", width: "10%", sortable: true },
                { title: "Client", value: this.CLIENT_NAME_HEADER_VALUE, sortable: true },
                { title: "État", value: "status", sortable: true },
                { title: "N° Facture", value: "number", width: "20%", sortable: true },
                { title: "Date d'émission", value: "date", sortable: true },
                { title: "Date échéance", value: "dueDate", sortable: true },
                { title: "Montant HT", value: "netAmount", sortable: false },
                { title: "Montant TTC", value: "grossAmount", sortable: false },
                { title: "Mail", value: "mail", sortable: false },
            ];
        } else {
            headers = [
                { title: "", value: "checkboxSelection", width: "64px", sortable: false },
                { title: "Titre", value: "title", sortable: true },
                { title: "Type", value: "type", width: "10%", sortable: true },
                { title: "Client", value: this.CLIENT_NAME_HEADER_VALUE, sortable: true },
                { title: "État", value: "status", sortable: true },
                { title: "N° Facture", value: "number", width: "20%", sortable: true },
                { title: "Date d'émission", value: "date", sortable: true },
                { title: "Date échéance", value: "dueDate", sortable: true },
                { title: "Montant", value: "grossAmount", sortable: false },
                { title: "Mail", value: "mail", sortable: false },
            ];
        }
        return headers;
    }

    get quotationsHeaders() {
        let headers = [];
        if (!isNotSubjectToVAT(this.selectedCompany.vatSystem)) {
            headers = [
                { title: "", value: "checkboxSelection", width: "64px", sortable: false },
                { title: "Titre", value: "title", sortable: true },
                { title: "Client", value: this.CLIENT_NAME_HEADER_VALUE, sortable: true },
                { title: "État", value: "status", sortable: true },
                { title: "N° Devis", value: "number", width: "20%", sortable: true },
                { title: "Date d'émission", value: "date", sortable: true },
                { title: "Date de validité", value: "dueDate", sortable: true },
                { title: "Montant HT", value: "netAmount", sortable: true },
                { title: "Montant TTC", value: "grossAmount", sortable: true },
                { title: "Mail", value: "mail", sortable: false },
            ];
        } else {
            headers = [
                { title: "", value: "checkboxSelection", width: "64px", sortable: false },
                { title: "Titre", value: "title", sortable: true },
                { title: "Client", value: this.CLIENT_NAME_HEADER_VALUE, sortable: true },
                { title: "État", value: "status", sortable: true },
                { title: "N° Devis", value: "number", width: "20%", sortable: true },
                { title: "Date d'émission", value: "date", sortable: true },
                { title: "Date de validité", value: "dueDate", sortable: true },
                { title: "Montant", value: "netAmount", sortable: true },
                { title: "Mail", value: "mail", sortable: false },
            ];
        }
        return headers;
    }

    get productHeaders() {
        let headers;
        if (!isNotSubjectToVAT(this.selectedCompany.vatSystem)) {
            headers = [
                { title: "Référence", value: "reference", sortable: true },
                { title: "Titre", value: "title", sortable: true },
                { title: "Type", value: "type", sortable: true },
                // { title: "% Remise", value: "percentage" },
                { title: "Prix unitaire", value: "unitPrice", sortable: true },
                { title: "% TVA", value: "vatRate", sortable: true },
                { title: "Obsolète", value: "outDated", sortable: true },
                { title: "Stocker", value: "stock", sortable: true },
            ];
        } else {
            headers = [
                { title: "Référence", value: "reference", sortable: true },
                { title: "Titre", value: "title", sortable: true },
                { title: "Type", value: "type", sortable: true },
                { title: "Prix unitaire", value: "unitPrice", sortable: true },
                { title: "Obsolète", value: "outDated", sortable: false },
                { title: "Stocker", value: "stock", sortable: false },
            ];
        }
        return headers;
    }

    get billDeliveriesHeaders() {
        const headers = [
            { title: "", value: "checkboxSelection", width: "64px", sortable: false },
            { title: "Client", value: this.CLIENT_NAME_HEADER_VALUE, width: "30%", sortable: true },
            { title: "État", value: "status", sortable: true },
            { title: "N° Bon de livraison", value: "number", width: "20%", sortable: true },
            { title: "Date d'émission", value: "dueDate", sortable: true },
        ];
        return headers;
    }

    get statusList() {
        return [
            { value: "ALL", text: "Tous" },
            { value: "DRAFT", text: this.$t("invoice.DRAFT") as string },
            { value: "BEING_VALIDATED", text: this.$t("invoice.BEING_VALIDATED") as string },
            { value: "VALIDATED", text: this.$t("invoice.VALIDATED") as string },
            { value: "ACCEPTED", text: this.$t("invoice.ACCEPTED") as string },
            // { value: 'PAID', text: (this.$t('invoice.PAID') as string) },
        ];
    }

    get typesList() {
        return [
            { value: "ALL", text: "Tous" },
            { value: "INVOICE", text: "Facture" },
            { value: "INVOICE_RECURRENT", text: "Facture récurente" },
            { value: "CREDIT_NOTE", text: "Avoir sur facture" },
            { value: "INVOICE_MATRIX", text: "Matrice de facture" },
        ];
    }

    clientCompanyName = "";

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "document", "read");
        return authorized;
    }

    get currentUser() {
        return this.$store.state.user;
    }

    productDialog = false;

    importProductsDialog = false;

    savingProduct = false;

    @State2Way("updateInvoiceActiveTab", "invoice.activeTab")
    activeTab!: string;

    /**
     * Format the *.sortBy and *.descending in the expected v-data-table format
     */
    formatDataTableSortBy(options: {
        sortBy: string | [];
        descending: boolean | boolean[];
    }): { key: string; order: boolean | "asc" | "desc" }[] {
        const out = [];
        if (!options?.sortBy) {
            return [];
        }
        if (Array.isArray(options.sortBy)) {
            options.sortBy.forEach((item, index) => {
                let order;
                if (Array.isArray(options.descending)) {
                    const ordIndex = index < options.descending.length ? index : 0;
                    order = options.descending[ordIndex] === true ? "desc" : "asc";
                } else {
                    order = options.descending === true ? "desc" : "asc";
                }
                const obj = { key: item, order: order };
                out.push(obj);
            });
        } else {
            const order_ =
                Array.isArray(options.descending) && options.descending.length
                    ? options.descending[0]
                    : options.descending;
            const order = order_ === true ? "desc" : order_ === false ? "asc" : order_;
            out.push({ key: options.sortBy, order: order });
        }

        return out;
    }

    /**
     * Set *.sortBy and *.descending values in options
     */
    setSortByAndDescendingValues(
        options: { sortBy: string[]; descending: boolean[] },
        sortItems: { key: string; order: boolean | "asc" | "desc" }[],
    ): void {
        debugger;
        if (options && sortItems) {
            options.sortBy = sortItems.map((item) => item.key);
            options.descending = sortItems.map((item) =>
                typeof item.order === "boolean" ? item.order : item.order === "desc" ? true : false,
            );
        }
    }

    get quotationsSortBy(): { key: string; order: boolean | "asc" | "desc" }[] {
        return this.formatDataTableSortBy(this.quotationPagination);
    }

    set quotationsSortBy(val: { key: string; order: boolean | "asc" | "desc" }[]) {
        this.setSortByAndDescendingValues(this.quotationPagination, val);
    }

    get invoicesSortBy(): { key: string; order: boolean | "asc" | "desc" }[] {
        return this.formatDataTableSortBy(this.invoicePagination);
    }

    set invoicesSortBy(val: { key: string; order: boolean | "asc" | "desc" }[]) {
        this.setSortByAndDescendingValues(this.invoicePagination, val);
    }

    get billsDeliverySortBy(): { key: string; order: boolean | "asc" | "desc" }[] {
        return this.formatDataTableSortBy(this.billDeliveryPagination);
    }

    set billsDeliverySortBy(val: { key: string; order: boolean | "asc" | "desc" }[]) {
        this.setSortByAndDescendingValues(this.billDeliveryPagination, val);
    }

    get productsSortBy(): { key: string; order: boolean | "asc" | "desc" }[] {
        return this.formatDataTableSortBy(this.productPagination);
    }

    set productsSortBy(val: { key: string; order: boolean | "asc" | "desc" }[]) {
        this.setSortByAndDescendingValues(this.productPagination, val);
    }

    beforeMount() {
        if (this.$route.params.activeTab) {
            this.activeTab = this.$route.params.activeTab as string;
        }
        // this.subjectMailToSend = this.defaultSubject
        // this.textMail = this.defaultText
        this.addListener("invoice");
    }

    beforeDestroy() {
        this.removeListener();
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get companyOutstandingClient() {
        if (
            this.selectedCompany?.profile?.managementAuthorization &&
            (!this.selectedCompany?.profile?.managementAuthorizations ||
                this.selectedCompany?.profile?.managementAuthorizations.client)
        ) {
            return true;
        }
        return false;
    }

    invoiceTypesList = [
        { text: "Tous", value: "ALL" },
        { text: "Facture", value: "INVOICE" },
        { text: "Facture récurrente", value: "INVOICE_RECURRENT" },
        { text: "Avoir", value: "CREDIT_NOTE" },
    ];

    get numberInvoicesSendableByMails() {
        if (!this.numberInvoicesToSend) {
            return 0;
        }
        return this.numberInvoicesToSend;
    }

    _formatOrderBy(pagination): string {
        let fieldName =
            pagination.sortBy && pagination.sortBy.length ? pagination.sortBy[0] : undefined;
        if (!fieldName) return undefined;
        const descending =
            pagination.descending && pagination.descending.length
                ? pagination.descending[0]
                : undefined;
        if (descending === undefined) return undefined;
        fieldName += descending ? "_ASC" : "_DESC";
        return fieldName;
    }

    formatOrderByQuotation(): string {
        return this._formatOrderBy(this.quotationPagination);
    }

    formatOrderByInvoice() {
        return this._formatOrderBy(this.invoicePagination);
    }

    formatOrderByBillDelivery() {
        return this._formatOrderBy(this.billDeliveryPagination);
    }

    formatOrderByProducts() {
        return this._formatOrderBy(this.productPagination);
    }

    getProductType(product) {
        if (product?.accountableAccount?.name) {
            const prefix = product?.accountableAccount.name.substring(0, 3);
            switch (prefix) {
                case "701":
                    return "produits finis";
                case "702":
                    return "produits intermédiaires";
                // case "703":
                //     return ""
                case "704":
                    return "Travaux";
                case "705":
                    return "Études";
                case "706":
                    return "Services";
                case "707":
                    return "Marchandises";
                case "708":
                    return "Activités annexes";
                case "709":
                    return "Remise";
            }
        }
        return "";
    }

    @Apollo({
        query: gql`
            query products(
                $companyId: ID!
                $first: Int!
                $skip: Int!
                $search: String
                $orderBy: InvoiceProductOrderByInput
                $type: InvoiceProductType!
            ) {
                invoiceProducts(
                    where: {
                        title_contains: $search
                        OR: [
                            { company: { id: $companyId }, type: null }
                            { company: { id: $companyId }, type: $type }
                        ]
                        # outDated_not: true
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    reference
                    title
                    unitPrice
                    vatRate
                    outDated
                    stock
                    percentage
                    accountableAccount {
                        id
                        name
                    }
                    tag {
                        id
                        name
                    }
                    stockOperations(first: 1) {
                        id
                    }
                }
                invoiceProductsConnection(
                    where: {
                        title_contains: $search
                        OR: [
                            { company: { id: $companyId }, type: null }
                            { company: { id: $companyId }, type: $type }
                        ]
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.productLoading = true;
            return {
                type: "PRODUCT",
                companyId: this.companyId,
                first: this.productPagination.rowsPerPage,
                skip: (this.productPagination.page - 1) * this.productPagination.rowsPerPage,
                search: this.search.length > 0 ? this.search : undefined,
                orderBy: this.formatOrderByProducts(),
            };
        },
        skip() {
            return !this.companyId || this.activeTab !== "Product";
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.productLoading = false;
                if (data.invoiceProductsConnection && data.invoiceProductsConnection.aggregate) {
                    this.productPagination.totalItems =
                        data.invoiceProductsConnection.aggregate.count;
                }
                debugger;
                for (const p of data.invoiceProducts) {
                    if (p.outDated === null) {
                        p.outDated = true;
                    }
                    if (p.stock === null) {
                        p.stock = false;
                    }
                    p.type = this.getProductType(p);
                }
                this.products = data.invoiceProducts.sort(function (x, y) {
                    return x.outDated === y.outDated ? 0 : x.outDated ? 1 : -1;
                });
                // debugger
            }
        },
    })
    products: InvoiceProduct[] = [];

    @Apollo({
        query: gql`
            query invoices(
                $companyId: ID!
                $first: Int!
                $skip: Int!
                $minAmount: Float
                $maxAmount: Float
                $search: String
                $clientIds: [ID!]
                $orderBy: InvoiceOrderByInput
                $status: InvoiceStatus
                $types: [InvoiceType!]
                $startDate: DateTime
                $endDate: DateTime
            ) {
                invoices(
                    where: {
                        company: { id: $companyId }
                        OR: [
                            { title_contains: $search }
                            { number_contains: $search }
                            { client: { name_contains: $search } }
                        ]
                        type_in: $types
                        client: { id_in: $clientIds }
                        status: $status
                        grossAmount_gte: $minAmount
                        grossAmount_lte: $maxAmount
                        date_gte: $startDate
                        date_lte: $endDate
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    client {
                        id
                        name
                    }
                    status
                    type
                    title
                    date
                    dueDate
                    number
                    netAmount
                    grossAmount
                    document {
                        id
                        mails {
                            id
                            type
                            date
                            lastReadDate
                        }
                    }
                }
                invoicesConnection(
                    where: {
                        company: { id: $companyId }
                        OR: [
                            { title_contains: $search }
                            { number_contains: $search }
                            { client: { name_contains: $search } }
                        ]
                        type_in: $types
                        client: { id_in: $clientIds }
                        status: $status
                        grossAmount_gte: $minAmount
                        grossAmount_lte: $maxAmount
                        date_gte: $startDate
                        date_lte: $endDate
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.invoiceLoading = true;
            const result = {
                companyId: this.companyId,
                first: this.invoicePagination.rowsPerPage,
                skip: (this.invoicePagination.page - 1) * this.invoicePagination.rowsPerPage,
                minAmount: this.minAmount != 0 ? parseFloat(this.minAmount) : undefined,
                maxAmount: this.maxAmount != 0 ? parseFloat(this.maxAmount) : undefined,
                startDate: this.startDate ? getDBFormattedDate(this.startDate) : undefined,
                endDate: this.endDate ? getDBFormattedDate(this.endDate) : undefined,
                search: this.search || undefined,
                clientIds: this.invoiceFilter.clientCompaniesSelected.length
                    ? this.invoiceFilter.clientCompaniesSelected
                    : undefined,
                orderBy: this.formatOrderByInvoice(),
                status: this.status === "ALL" ? undefined : this.status,
                types: this.type === "ALL" ? this.allType : this.type,
            };
            return result;
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.companyId || this.activeTab !== "Invoice";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.invoiceLoading = false;
                if (data?.invoicesConnection?.aggregate) {
                    this.invoicePagination.totalItems = data.invoicesConnection.aggregate.count;
                }
                this.invoices = data.invoices;
                this.setTmpMail(this.invoices);
            }
        },
    })
    invoices = [];

    @Apollo({
        query: gql`
            query quotations(
                $companyId: ID!
                $skip: Int!
                $first: Int
                $search: String
                $clientIds: [ID!]
                $orderBy: InvoiceOrderByInput
                $status: InvoiceStatus
            ) {
                invoices(
                    where: {
                        company: { id: $companyId }
                        type: QUOTATION
                        title_contains: $search
                        client: { id_in: $clientIds }
                        status: $status
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    client {
                        id
                        name
                    }
                    status
                    title
                    date
                    dueDate
                    number
                    document {
                        id
                        mails {
                            id
                            type
                            date
                            lastReadDate
                        }
                    }
                    lines {
                        id
                        title
                        reference
                        quantity
                        unitPrice
                        netAmount
                        grossAmount
                        isOptional
                    }
                }
                invoicesConnection(
                    where: {
                        company: { id: $companyId }
                        type: QUOTATION
                        title_contains: $search
                        client: { id_in: $clientIds }
                        status: $status
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.quotationLoading = true;
            return {
                companyId: this.companyId,
                first: this.quotationPagination.rowsPerPage,
                skip: (this.quotationPagination.page - 1) * this.quotationPagination.rowsPerPage,
                minAmount: this.minAmount.length > 0 ? parseFloat(this.minAmount) : undefined,
                maxAmount: this.maxAmount.length > 0 ? parseFloat(this.maxAmount) : undefined,
                search: this.search.length > 0 ? this.search : undefined,
                clientIds: this.invoiceFilter.clientCompaniesSelected.length
                    ? this.invoiceFilter.clientCompaniesSelected
                    : undefined,
                orderBy: this.formatOrderByQuotation(),
                status: this.status === "ALL" ? undefined : this.status,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.companyId || this.activeTab !== "Quotation";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.quotationLoading = false;
                if (data.invoicesConnection && data.invoicesConnection.aggregate) {
                    this.quotationPagination.totalItems = data.invoicesConnection.aggregate.count;
                }
                this.quotations = data.invoices;
                this.setTmpMail(this.quotations);
                this.addAccountingLinesInEachQuotation();
            }
        },
    })
    quotations = [];

    /**
     * Adds the accountingLines and the net amount to the quotation object. so they can be displayed
     */
    addAccountingLinesInEachQuotation() {
        this.quotations.forEach((quotation) => {
            let grossAmount = 0;
            let netAmount = 0;
            quotation.lines.forEach((line) => {
                grossAmount += line.grossAmount;
                netAmount += line.netAmount;
            });
            quotation.grossAmount = grossAmount;
            quotation.netAmount = netAmount;
        });
    }

    @Apollo({
        query: gql`
            query BillDelivery(
                $companyId: ID!
                $skip: Int!
                $first: Int
                $search: String
                $clientIds: [ID!]
                $orderBy: InvoiceOrderByInput
                $status: InvoiceStatus
            ) {
                invoices(
                    where: {
                        company: { id: $companyId }
                        type: BILL_DELIVERY
                        title_contains: $search
                        client: { id_in: $clientIds }
                        status: $status
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    client {
                        id
                        name
                    }
                    status
                    title
                    date
                    number
                    document {
                        id
                    }
                }
                invoicesConnection(
                    where: {
                        company: { id: $companyId }
                        type: BILL_DELIVERY
                        title_contains: $search
                        client: { id_in: $clientIds }
                        status: $status
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.billDeliveryLoading = true;
            // debugger
            return {
                companyId: this.companyId,
                first: this.billDeliveryPagination.rowsPerPage,
                skip:
                    (this.billDeliveryPagination.page - 1) *
                    this.billDeliveryPagination.rowsPerPage,
                minAmount: this.minAmount.length > 0 ? parseFloat(this.minAmount) : undefined,
                maxAmount: this.maxAmount.length > 0 ? parseFloat(this.maxAmount) : undefined,
                search: this.search.length > 0 ? this.search : undefined,
                clientIds: this.invoiceFilter.clientCompaniesSelected.length
                    ? this.invoiceFilter.clientCompaniesSelected
                    : undefined,
                orderBy: this.formatOrderByBillDelivery(),
                status: this.status === "ALL" ? undefined : this.status,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.companyId || this.activeTab !== "BillDelivery";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.billDeliveryLoading = false;
                if (data.invoicesConnection && data.invoicesConnection.aggregate) {
                    this.billDeliveryPagination.totalItems =
                        data.invoicesConnection.aggregate.count;
                }
                this.billOfDelivery = data.invoices;
            }
        },
    })
    billOfDelivery = [];

    @Apollo({
        query: CUSTOMER_COMPANIES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
    })
    customerCompanies: Array<any> = [];

    @Apollo({
        query() {
            return INVOICES_TO_SEND_BY_MAILS;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                companyId: this.companyId,
                // skip: ((this.invoicePagination.page - 1) * this.invoicePagination.rowsPerPage),
                clientIds: this.clientCompaniesSelected.length
                    ? this.clientCompaniesSelected
                    : undefined,
                // orderBy: this.formatOrderByInvoice()
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.invoicesToSendByMails) {
                    this.numberInvoicesToSend = data.invoicesToSendByMails.counts;
                } else {
                    this.numberInvoicesToSend = 0;
                }
            }
        },
    })
    numberInvoicesToSend = 0;

    @Apollo({
        query: gql`
            query CompanyQuery($companyId: ID!) {
                company(where: { id: $companyId }) {
                    id
                    name
                    profile {
                        id
                        sendingMailSMTPConfig
                    }
                }
            }
        `,
        variables() {
            return {
                companyId: this.$store.state.selected_company.id,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.$store.state.selected_company.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (
                    data &&
                    data.company &&
                    data.company.profile &&
                    data.company.profile.sendingMailSMTPConfig
                ) {
                    this.credentialsEmailAddresses = JSON.parse(
                        JSON.stringify(data.company.profile.sendingMailSMTPConfig.users),
                    );
                    this.credentialsEmailAddresses.push({
                        email: "Utiliser l'adresse mail de bobbee",
                    });
                    if (this.credentialsEmailAddresses.length) {
                        this.mailAddressSender = this.credentialsEmailAddresses[0].email;
                    }
                } else {
                    this.credentialsEmailAddresses = [
                        {
                            email: "Utiliser l'adresse mail de bobbee",
                        },
                    ];
                    this.mailAddressSender = "Utiliser l'adresse mail de bobbee";
                    // console.log("AccountableAccountVue data pb");
                    // this.thirdPartyAccountableAccounts.splice(0, this.thirdPartyAccountableAccounts.length);
                }
            }
        },
    })
    credentialsEmailAddresses: Array<any> = [];

    // async sendMails() {  // not used because of unclarity for user
    //     const info = await this.$apollo.mutate({
    //         mutation: SEND_MULTIPLE_INVOICES_BY_MAILS,
    //         variables: {
    //             clientsId: this.clientCompaniesSelected.length ? this.clientCompaniesSelected : undefined,
    //             userId: this.$store.state.user.id,
    //             profileCompanyId: this.$store.state.user.company.profile.id,
    //             subject: this.subjectMailToSend,
    //             credentialsSender: this.mailAddressSender === "Utiliser l'adresse mail de bobbee" ? 'useBobbeeEmailAddress' : this.mailAddressSender,
    //             textMail: this.textMail,
    //             companyId: this.companyId,
    //             // receiversEmailAddresses: this.receiversEmailAddresses
    //         },
    //     })
    //     if (info.data.multipleInvoicesMailer.info) {
    //         this.sendingMailLoading = false
    //         this.$apollo.queries.numberInvoicesToSend.refetch()
    //     }
    // }

    formatDate(date: Date) {
        if (!date) return "-";
        return moment(date).format("DD/MM/YYYY");
    }

    editProduct(p) {
        this.productId = p.id;
        this.productDialog = true;
    }

    clearFilter() {
        this.clientCompaniesSelected = [];
        this.search = "";
        this.minAmount = "";
        this.maxAmount = "";
    }

    onProductSaved() {
        this.productDialog = false;
        if (this.$apollo.queries.products) {
            this.$apollo.queries.products.refetch();
        }
        this.productId = "";
    }

    setThirdPartyCompanyName(thirdPartyCompanyName: string) {
        if (thirdPartyCompanyName === "") {
            this.clientCompaniesSelected = [];
            this.invoiceFilter.clientCompaniesSelected = [];
            return;
        }
        this.invoiceFilter.clientCompaniesSelected = [
            this.customerCompanies.find((c) => c.name === thirdPartyCompanyName).id,
        ];
    }

    setTmpMail(invoicesList) {
        for (const invoice of invoicesList) {
            let tmpMail: {
                id: String;
                type: String;
                date: String;
                lastReadDate: String;
            } = null;

            if (invoice.document?.mails) {
                for (const mail of invoice.document.mails) {
                    if (!tmpMail) {
                        tmpMail = mail;
                    } else if (
                        !tmpMail.lastReadDate &&
                        !mail.lastReadDate &&
                        tmpMail.date < mail.date
                    ) {
                        tmpMail = mail;
                    } else if (!tmpMail.lastReadDate && mail.lastReadDate) {
                        tmpMail = mail;
                    } else if (
                        tmpMail.lastReadDate &&
                        mail.lastReadDate &&
                        tmpMail.lastReadDate < mail.lastReadDate
                    ) {
                        tmpMail = mail;
                    }
                }
            }
            invoice.mail = tmpMail;
        }
    }

    async setOutDatedProduct(item, state: boolean) {
        // debugger;
        const response = await this.$apollo.mutate({
            mutation: gql`
                mutation outDatedProduct($id: ID!, $outDated: Boolean!) {
                    updateInvoiceProduct(where: { id: $id }, data: { outDated: $outDated }) {
                        id
                    }
                }
            `,
            variables: {
                id: item.id,
                outDated: state,
            },
        });
        // this.products.filter(x => x.id !== id)
    }

    async setStockProduct(productId, isStocked) {
        try {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation setStockProduct($id: ID!, $isStocked: Boolean!) {
                        updateInvoiceProduct(where: { id: $id }, data: { stock: $isStocked }) {
                            id
                        }
                    }
                `,
                variables: {
                    id: productId,
                    isStocked: isStocked,
                },
            });
            const product = this.products.find((p) => p.id === productId);
            product.stock = isStocked;
        } catch (error) {
            console.error(error);
        }
    }

    onDocumentImported() {
        this.onProductSaved();
        this.importProductsDialog = false;
        this.$emit("refresh");
    }

    async retrieveSignatures() {
        debugger;
        this.synchronisationLoading = true;
        const result = await this.$apollo.mutate({
            mutation: GET_SIGNATURES,
            variables: {
                companyId: this.selectedCompany.id,
            },
        });
        if (result.data?.synchroniseSignTransactions?.success) {
            this.synchronisationLoading = false;
        }
        this.$emit("refresh");
    }

    @Watch("invoiceDialog")
    reset() {
        if (this.$refs.invoiceEditWizard) {
            this.$refs.invoiceEditWizard.reset();
        }
    }

    @Watch("selectedCompany")
    checkRightsAccess() {
        if (
            this.activeTab === "Rights" &&
            this.selectedCompany?.profile?.managementAuthorizations?.client
        ) {
            this.activeTab = "Invoice";
        }
    }

    @Watch("companyId")
    @Watch("search")
    @Watch("clientCompaniesSelected")
    @Watch("status")
    @Watch("minAmount")
    @Watch("maxAmount")
    resetPagination() {
        this.invoicePagination.page = 1;
        this.productPagination.page = 1;
        this.quotationPagination.page = 1;
        this.billDeliveryPagination.page = 1;
    }

    onMessageCheckList(data, list) {
        if (data.action === "update") {
            const index = list.findIndex((aie) => aie.id === data.id);
            if (index !== -1) {
                if (data.payload && data.extraPayload) {
                    data.payload.extraData = data.extraPayload;
                }
                this.invoices.splice(index, 1, data.payload);
                return true;
            }
        } else if (data.action === "delete") {
            const index = this.invoices.findIndex((aie) => aie.id === data.id);
            if (index !== -1) {
                this.invoices.splice(index, 1);
                return true;
            }
        }
        return false;
    }

    onMessage(data) {
        console.log("on message invoices");
        if (data) {
            if (data.action === "create") {
                // nothing to do
            }
            if (!this.onMessageCheckList(data, this.invoices)) {
                if (!this.onMessageCheckList(data, this.billOfDelivery)) {
                    this.onMessageCheckList(data, this.quotations);
                }
            }
        }
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }

    addDocument(type: "quotation" | "invoice" | "billDelivery" | "invoiceRecurrence") {
        this.invoiceType = type;
        if (this.$store.state.invoice?.skipWizard) {
            this.$router.push({
                name: `${this.invoiceType}New`,
                params: { companyId: this.selectedCompany.id },
            });
        } else {
            this.invoiceDialog = true;
        }
    }

    // -- Conversion --      la conversion permet de générer une nouvelle facture (ou bill ou devis) grâce au regroupement de plusieurs bill, devis ou factures => la nouvelle facture est générée avec toutes les lignes de toutes les factures séléctionnées
    get selectedInvoiceObjects() {
        if (this.activeTab === "Quotation") {
            return this.quotations.filter((i) => this.selectedInvoices.includes(i.id));
        }
        if (this.activeTab === "Invoice") {
            return this.invoices.filter((i) => this.selectedInvoices.includes(i.id));
        }
        if (this.activeTab === "BillDelivery") {
            return this.billOfDelivery.filter((i) => this.selectedInvoices.includes(i.id));
        }
    }

    @Watch("activeTab")
    reinitialiseSelectedInvoices() {
        this.selectedInvoices = [];
    }

    get disableConvertInvoicesDialog() {
        if (!this.selectedInvoices?.length) {
            return true;
        } else {
            if (
                this.selectedInvoiceObjects.some(
                    (i) => i.client.id !== this.selectedInvoiceObjects[0].client?.id,
                )
            ) {
                return "Toutes les factures sélectionnées doivent avoir le même client";
            }
            // if(this.selectedInvoices.some(i => !i.title)) {
            //     return "Toutes les factures sélectionnées doivent avoir un titre"
            // }
            if (this.selectedInvoiceObjects.some((i) => i.type === "CREDIT_NOTE")) {
                return "Ne peut pas convertir d'avoir ";
            }
            if (this.selectedInvoiceObjects.some((i) => i.type === "INVOICE_MATRIX")) {
                return "Ne peut pas convertir de matrice ";
            }
            if (this.selectedInvoiceObjects.some((i) => i.type === "INVOICE_RECURRENT")) {
                return "Ne peut pas convertir de facture récurrente ";
            }
            return false;
        }
    }

    get displayDisableConvertInvoicesDialog() {
        if (typeof this.disableConvertInvoicesDialog === "boolean") {
            return "Copier en un autre format (ex: un devis en facture)";
        } else {
            return this.disableConvertInvoicesDialog;
        }
    }

    get selectedInvoicesHaveOptionalLines() {
        for (const sL of this.selectedInvoiceObjects) {
            if (this.invoicesIdHaveBeenChecked.find((e) => e === sL.id)) {
                continue;
            }
            if (sL.lines?.some((l) => l.isOptional)) {
                return true;
            }
        }
        return false;
    }

    isSelected(invoiceId) {
        if (this.selectedInvoices.findIndex((i) => i === invoiceId) !== -1) {
            return true;
        }
        return false;
    }

    isNotSelectionable(invoiceId) {
        const invoice = this.invoices.find((i) => i === invoiceId);
        if (invoice) {
            if (invoice.type === "INVOICE_MATRIX") {
                return true;
            }
            if (invoice.depositOf) {
                return true;
            }
        }
        return false;
    }

    convertMultipleInvoiceLoading = false;
    async convertInvoice() {
        this.convertMultipleInvoiceLoading = true;
        let optionalLinesToKeep = [];
        if (this.activeTab === "Quotation") {
            for (const sI of this.selectedInvoiceObjects) {
                const linesToKeepOfSI = sI.lines.filter((l) => l.keepTheLine).map((l) => l.id);
                optionalLinesToKeep = optionalLinesToKeep.concat(linesToKeepOfSI);
            }
        }
        const newInvoice = await this.$apollo.mutate({
            mutation: CONVERT_INVOICES,
            variables: {
                invoicesToConvert: this.selectedInvoices.map((i) => i),
                conversionType: this.conversionType,
                optionalLinesToKeep:
                    this.activeTab === "Quotation" ? optionalLinesToKeep : undefined,
            },
        });
        this.convertMultipleInvoiceLoading = false;
        this.convertMultipleInvoiceDialog = false;
        this.$router.push({
            name: "invoiceEdition",
            params: { companyId: this.companyId, id: newInvoice.data.convertInvoices.id },
        });
    }

    width = "50%";
    changeWidth() {
        if (this.$refs.importComponent?.step !== 0) {
            this.width = "75%";
        } else {
            this.width = "60%";
        }
    }

    @Watch("convertMultipleInvoiceDialog")
    reinitialiseTab() {
        this.invoicesIdHaveBeenChecked = [];
    }
}

export default toNative(InvoiceTable);
</script>

<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}
</style>
